import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Axios from '../../../../common/util/Axios';
import store from '../../../../store';

export const ReplacementLink = ({ supplierId, value, returnNo, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const companyId = store.getState().authState.companyId;
      const branchId = store.getState().authState.branchId;
      if (!supplierId || !branchId) {
        setOptions([]);
        return;
      }
      try {
        const res = await Axios.get('/api/dashboard/supplier-return/find-all', {
          params: { companyId, branchId, supplierId },
        });
        if (!cancelled) {
          setOptions(Array.isArray(res.data?.data) ? res.data.data : []);
        }
      } catch {
        if (!cancelled) setOptions([]);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [supplierId]);

  const known = options.some((row) => String(row.id) === String(value));

  return (
    <div>
      <label htmlFor="relatedSupplierReturnId">Return No.</label>
      <select
        id="relatedSupplierReturnId"
        aria-label="Return No."
        value={value || ''}
        onChange={(event) => {
          const next = event.target.value;
          const row = options.find((item) => String(item.id) === next);
          onChange(next, row ? row.returnNo : '');
        }}
      >
        <option value=""> </option>
        {!known && value ? <option value={value}>{returnNo || value}</option> : null}
        {options.map((row) => (
          <option key={row.id} value={row.id}>
            {`${row.returnNo} ${row.status || ''}`.trim()}
          </option>
        ))}
      </select>
      {value ? <p>Post the return, then record a new receive.</p> : null}
    </div>
  );
};

ReplacementLink.propTypes = {
  supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.string,
  returnNo: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ReplacementLink.defaultProps = {
  supplierId: '',
  value: '',
  returnNo: '',
};

export const ReplacementChip = ({ id, returnNo }) => {
  const navigate = useNavigate();
  if (!id || !returnNo) return null;
  return (
    <button
      type="button"
      aria-label={`Replacement for Supplier Return: ${returnNo}`}
      style={{
        backgroundColor: '#eff6ff',
        color: '#3b82f6',
        borderRadius: '999px',
        border: 'none',
        padding: '2px 10px',
        cursor: 'pointer',
        fontWeight: 600,
      }}
      onClick={() => navigate(`/inventory/supplier-returns/${id}`)}
    >
      {`Replacement for Supplier Return: ${returnNo}`}
    </button>
  );
};

export const AppliedChip = ({ id, returnNo }) => {
  const navigate = useNavigate();
  if (!id || !returnNo) return null;
  const label = `Applied Supplier Return: ${returnNo}`;
  return (
    <button
      type="button"
      aria-label={label}
      style={{
        backgroundColor: '#eff6ff',
        color: '#3b82f6',
        borderRadius: '999px',
        border: 'none',
        padding: '2px 10px',
        cursor: 'pointer',
        fontWeight: 600,
      }}
      onClick={() => navigate(`/inventory/supplier-returns/${id}`)}
    >
      {label}
    </button>
  );
};

ReplacementChip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  returnNo: PropTypes.string,
};

AppliedChip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  returnNo: PropTypes.string,
};

AppliedChip.defaultProps = {
  id: '',
  returnNo: '',
};

ReplacementChip.defaultProps = {
  id: '',
  returnNo: '',
};
